import { render, staticRenderFns } from "./nav.vue?vue&type=template&id=38a2107c&scoped=true&"
import script from "./nav.vue?vue&type=script&lang=js&"
export * from "./nav.vue?vue&type=script&lang=js&"
import style0 from "./nav.vue?vue&type=style&index=0&id=38a2107c&prod&lang=scss&scoped=true&"
import style1 from "./nav.vue?vue&type=style&index=1&id=38a2107c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38a2107c",
  null
  
)

export default component.exports